const JourneyInstructor = [
  'Effortless quiz creation from your documents. Engage students effectively.',
  'Create custom quizzes for engaging assessments and set rules in advance.',
  'Instant AI grading for timely feedback and better learning.',
  'Proctor-based, secure, reliable online exams for fair assessments',
  'Seamless student enrolment and progress tracking made simple and many more.'
]

export default JourneyInstructor
